
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return require("private-next-pages/careers/index.js");
      }
    ]);
  